import { LitElement, html } from 'lit';
import { style } from './error-message.style';
import { DebugService } from '@services/debug.service';
import { customElement, property } from 'lit/decorators.js';

@customElement('refi-error-message')
export class RefiErrorMessage extends LitElement {
  debug: DebugService = new DebugService('ErrorMessageComponent');

  @property({ type: String, attribute: true })
  message: string = '';

  static get styles() {
    return style;
  }

  render() {
    return html`
      <div class="error-message-container">
        <img src="assets/caution.svg" alt="Caution" />
        <p>${this.message}</p>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'refi-error-message': RefiErrorMessage;
  }
}
